var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLeftArrow = function SvgLeftArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.16,
    height: 11.555,
    viewBox: "7.04 4.306 6.16 11.555"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 280330"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.91 4.666a.352.352 0 0 0-.51 0 .352.352 0 0 0 0 .51l5.176 5.14L7.4 15.492a.352.352 0 0 0 0 .51.33.33 0 0 0 .255.11.33.33 0 0 0 .255-.11l5.431-5.395a.33.33 0 0 0 .11-.255.33.33 0 0 0-.11-.255L7.91 4.666Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91 4.666a.352.352 0 0 0-.51 0 .352.352 0 0 0 0 .51l5.176 5.14L7.4 15.492a.352.352 0 0 0 0 .51.33.33 0 0 0 .255.11.33.33 0 0 0 .255-.11l5.431-5.395a.33.33 0 0 0 .11-.255.33.33 0 0 0-.11-.255L7.91 4.666Z",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.5,
    stroke: "#000",
    fill: "transparent"
  }))));
};
export default SvgLeftArrow;